module.exports = __webpack_public_path__ + "img/running-mt-car.73af6f14.jpg";